// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"3cf4adf6","461":"2ee8e7ff","469":"090988a4","942":"56e2d812"}[chunkId] + ".chunk.css";
};